import { type Nil, isString } from "@mcwd/typescript-type-guards";
import { ComputedValueGetter } from "../../utils/ComputedValueGetter.js";
import { getGeoLocationDataSync } from "../onetrust/getOneTrustValues.js";

export function getGeoLocationData(): GeoLocationData | Nil
{
  const otGeoLocData = getGeoLocationDataSync();
  const countryCode = otGeoLocData?.countryCode?.trim()?.toUpperCase();
  const stateCode = otGeoLocData?.stateCode?.trim()?.toUpperCase();
  if (isString(countryCode) && countryCode !== "") {
    if (isString(stateCode) && stateCode !== "") {
      return { countryCode, stateCode };
    }
    return { countryCode };
  }
  return null;
}

type GeoLocationData = { countryCode: string, stateCode?: string | Nil };
export const GeoLocation = new ComputedValueGetter({
  isLazy: true,
  computeFn: getGeoLocationData
});